const now = new Date();
const today =
  now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();

export const auditeventsresponse = {
  events: [
    {
      timestamp: today + 'T05:03:58.546Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T05:03:57.435400Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T05:03:55.729744Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T05:03:55.729498Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T04:42:49.715651Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T04:42:49.715194Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T04:42:49.156299Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T04:42:49.156030Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T04:42:48.773277Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T04:42:48.773099Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T04:42:05.304815Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T04:42:05.297055Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T04:37:54.450217Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'application',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T04:37:54.449951Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'application',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T04:29:40.238505Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'application',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T04:29:40.238317Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'application',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T01:15:34.825846Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T01:15:34.825565Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T01:15:34.001904Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T01:15:34.001034Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T01:15:33.561225Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T01:15:33.560174Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T01:14:41.743788Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T01:14:41.742988Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
    {
      timestamp: today + 'T01:14:13.969356Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '"Test"',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: 'Test',
      },
    },
    {
      timestamp: today + 'T01:14:13.954901Z',
      principal: 'anonymous',
      type: 'CREATE_TEST',
      data: {
        json: '{"id":"12345","timestamp":"2021-10-12T14:48:34.738201+08:00","gender":"M"}',
        source: 'DUM',
        sessionId: 'anonymous',
        objectId: '12345',
      },
    },
  ],
};
